









import { Component, Vue, Provide } from 'vue-property-decorator';
import List from '@/components/List.vue';
import Login from './Login.vue';

@Component({
    components: {
        List,
        Login,
    },
})
export default class Home extends Vue {
    @Provide() public openFullscreen: boolean = false;

    public closeLogin() {
        this.openFullscreen = false;
    }

    public openLogin() {
        this.openFullscreen = true;
    }
}
